<template>
  <div class="search-view">
    <header id="blog-header">
      <div class="inner">
        <slot name="headContent"></slot>
        <search-bar
          v-model="keyword"
          @search="handleSearch"
          :suggestions="suggestions"
        ></search-bar>
      </div>
    </header>
    <all-blogposts v-if="hasQuery" func="search" :search-query="currentQuery"></all-blogposts>
  </div>
</template>

<script>
import allBlogposts from './AllBlogPosts'
import SearchBar from '../components/SearchBar'
import { fetchSearchSuggestions } from '../utils/search'

export default {
  name: 'search',
  components: {
    allBlogposts,
    SearchBar
  },
  data () {
    return {
      keyword: this.$route.query.q || '',
      suggestions: []
    }
  },
  created () {
    this.loadSuggestions()
  },
  computed: {
    currentQuery () {
      return this.$route.query.q || ''
    },
    hasQuery () {
      return this.currentQuery.trim() !== ''
    }
  },
  watch: {
    '$route.query.q' (newVal) {
      this.keyword = newVal || ''
    }
  },
  methods: {
    async loadSuggestions () {
      this.suggestions = await fetchSearchSuggestions(this.$http, this.$store.state.baseUrl)
    },
    handleSearch (query) {
      const trimmed = (query || '').trim()
      this.keyword = trimmed
      if (!trimmed) {
        this.$router.push({ name: 'search' })
        return
      }
      this.$router.push({
        name: 'search',
        query: {
          q: trimmed,
          page: 1
        }
      })
    }
  }
}
</script>

<style scoped>
.search-view {
  background: #fff;
}
</style>
